import React from "react";
import { Route, Switch } from "react-router-dom";
import { Paths } from "Paths";
import { Calendar } from "pages/booking/Calendar";
import { Booking } from "pages/booking";
import { SystemError } from "pages/error/SystemError";
import { Confirm } from "pages/confirmPage";
import { Signin } from "pages/signin/Signin";

const routes = (
    <Switch>
        <Route exact path={Paths.top} component={Calendar} />
        <Route exact path={Paths.booking} component={Booking} />
        <Route exact path={Paths.signin} component={Signin} />
        <Route exact path={Paths.systemBusy} component={SystemError} />
        <Route exact path={Paths.confirm + `/:id`} component={Confirm} />
    </Switch>
);

export default routes;
